import { render, staticRenderFns } from "./ActivityDate.vue?vue&type=template&id=18362708&scoped=true"
import script from "./ActivityDate.vue?vue&type=script&lang=js"
export * from "./ActivityDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18362708",
  null
  
)

export default component.exports